/**
 * Licensed Materials - Property of FIWE.
 * (C) Copyright FIWE  2024.
 */

import { customSeries } from 'integration/generated/custom';
import { CustomSeriesVariantsResult } from 'integration/generated/custom/data-contracts';

/**
 * This REST service method returns series variant information.
 */
export const DATA_KEY_CATENTRY = 'customSeriesGetVariantsByCatentryId';
export const variantsByCatentryIdFetcher =
	(pub: boolean) =>
	async (
		storeId: string,
		catalogId: string,
		catentryId: string
	): Promise<CustomSeriesVariantsResult | undefined> => {
		try {
			return await (customSeries(pub).seriesGetVariantsByCatentryId(
				storeId,
				catalogId,
				catentryId
			) as Promise<unknown> as Promise<CustomSeriesVariantsResult>);
		} catch (error: any) {
			console.error(error);
			return undefined;
		}
	};

export const DATA_KEY_SERIES = 'customSeriesGetVariantsBySeries';
export const variantsBySeriesFetcher =
	(pub: boolean) =>
	async (
		storeId: string,
		catalogId: string,
		series: string | null
	): Promise<CustomSeriesVariantsResult | undefined> => {
		if (series === null) return undefined;
		try {
			return await (customSeries(pub).seriesGetVariantsBySeries(
				storeId,
				catalogId,
				series
			) as Promise<unknown> as Promise<CustomSeriesVariantsResult>);
		} catch (error: any) {
			console.error(error);
			return undefined;
		}
	};
